export default __webpack_public_path__ + "static/hero-l8-1-65fa50e22eb66edc5cd8d202fea55d86.png";